import { LabelConfigVariant, Ref } from '@repo/sdk/models/components';

import { getRefValue } from '@/features/equipment-browser/utils';
import { formatUnits } from '@/helpers/unit-formatter/unit-formatter';

import { AnimaticLabel, AnimaticLabelMap, LabelConfigMap } from './types';

// Gets the banner label from the label configs
// The Banner text is taken from the value of the label config
// The Banner sub text is taken from the ref of the label config if it exists
export const getBannerLabel = (labelConfigs: LabelConfigMap): AnimaticLabel | undefined => {
  for (const labelConfig of Object.values(labelConfigs)) {
    // Return the first banner label
    if (labelConfig.isBanner) {
      const subText = labelConfig.ref
        ? parseLabelRef(labelConfig.ref, labelConfig.displayUnits)
        : undefined;
      return {
        text: labelConfig.value ?? '',
        variant: labelConfig.variant ?? LabelConfigVariant.Primary,
        subText: subText,
      };
    }
  }
  return undefined;
};

// Converts a ref to a label text
export const parseLabelRef = (ref: Ref, displayUnits?: string) => {
  const value = getRefValue(ref) ?? null;
  // If ref.units is not configured, infer from value type
  // For boolean values, use 'boolean' as source units to enable transformation
  let sourceUnits = ref.units;
  if (!sourceUnits) {
    sourceUnits = typeof value === 'boolean' ? 'boolean' : displayUnits;
  }
  const formattedLabels = formatUnits({ value, units: sourceUnits }, displayUnits);
  return formattedLabels.valueUnitsLabel;
};

export const getAnimaticLabels = (labelConfigs: LabelConfigMap): AnimaticLabelMap => {
  const animaticLabels: { [key: string]: AnimaticLabel } = {};
  Object.entries(labelConfigs).forEach(([key, labelConfig]) => {
    if (labelConfig.isBanner) {
      return;
    }
    const animaticLabel: AnimaticLabel = {
      text: labelConfig.value ?? '',
      variant: labelConfig.variant ?? LabelConfigVariant.Primary,
    };
    animaticLabel.text = labelConfig.value ?? '';
    if (labelConfig.ref) {
      animaticLabel.text = parseLabelRef(labelConfig.ref, labelConfig.displayUnits);
    }
    animaticLabels[key] = animaticLabel;
  });
  return animaticLabels;
};
